<template>
	<section class="body">
		<main class="container mt-12 py-12">

			<div class="lng-btns" v-show="true">
				<a v-if="$parent.$i18n.locale == 'de'" @click.prevent="setLanguage('en')" class="lng-en"><img src="/assets/images/gb.svg"/></a>
				<a v-if="$parent.$i18n.locale == 'en'" @click.prevent="setLanguage('de')" class="lng-de"><img src="/assets/images/de.svg"/></a>
			</div>

			<div class="row">
				<div class="col text-center">
					<img src="/assets/images/hellers24.svg" class="logo mb-20"/>
					<h1 class="mb-3">{{ $t('checkin.selectType.checkinslogan') }}</h1>
					<p class="mb-16">{{ $t('checkin.selectType.checkinwelcome')}}</p>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<div class="btn-wrap mb-12">
						<a @click.prevent="nextStep" class="btn btn-primary btn-gold w-100">{{ $t('checkin.selectType.checkin')}}<br/><span class="subtext">{{ $t('checkin.selectType.checkinsubtext')}}</span></a>
					</div>
				</div>
				<div class="col-md-6">
					<div class="btn-wrap mb-12">
						<a @click.prevent="booking" class="btn btn-primary btn-gold w-100">{{ $t('checkin.selectType.booking')}}<br/><span class="subtext">{{ $t('checkin.selectType.bookingsubtext')}}</span></a>
					</div>
				</div>
			</div>
		</main>
	</section>
</template>

<script>
    export default {
        props: [],
        data: function () {
            return {
              countDown: 0,
              countStart: 30
            }
        },
        created() {
            // this.$parent.$i18n.locale = 'de';
	        this.$parent.direction = true;
	        this.$parent.guest = null;
          // this.startCountDown();
	    	},
        methods: {
          nextStep() {
	          this.$parent.direction = true;
            this.$parent.component = 'CheckinLogin';
			    },

	        booking() {
		        this.$parent.direction = true;
		        this.$parent.component = 'CheckinSelectRoom';
	        },

          setLanguage(lang) {
            this.$parent.$i18n.locale = lang;
          }
        },
        components: {}
    }
</script>

<style scoped lang="scss">
.btn-wrap .btn-primary {
	padding: 1.5rem;
}
</style>
